import currentUserStore from 'stores/CurrentUserStore';

const hasRoleForAtLeastOneProgram = (roleToken) => {
  const { redseaRolesToProgramsMap } = currentUserStore ? currentUserStore.userStore : {};
  return Boolean(redseaRolesToProgramsMap && redseaRolesToProgramsMap[roleToken]);
};

export default hasRoleForAtLeastOneProgram;
